import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { ProjectView } from "../features/memory/index.ts";
import { useAppParams } from "../shared/hooks/useAppParams.ts";

export const MemoryProject: FC = () => {
  const { projectId } = useAppParams("MemoryProject");

  return (
    <PageContainer>
      <ProjectView projectId={projectId} />
    </PageContainer>
  );
};
